import React from "react";
import ReactDOM from "react-dom";
import { HiExclamation } from "react-icons/hi";
import "../styles.css";

export default function ModalConfirmacion({ visible, titulo, mensaje, onConfirmar, onCancelar, tipo = "rojo" }) {
  if (!visible) return null;

  const modalContent = (
    <div className="modal-overlay" style={{ zIndex: 1200 }}>
      <div className="modal animate-fadeIn" style={{ maxWidth: '400px', textAlign: 'center' }}>
        <div style={{
          width: '60px',
          height: '60px',
          background: tipo === 'rojo' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(16, 185, 129, 0.1)',
          color: tipo === 'rojo' ? 'var(--accent-danger)' : 'var(--accent-success)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: '1.8rem'
        }}>
          <HiExclamation />
        </div>

        <h3 style={{ marginTop: 0, marginBottom: '12px' }}>{titulo}</h3>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '24px', lineHeight: 1.5 }}>{mensaje}</p>

        <div className="modal-footer" style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '16px',
          marginTop: '8px'
        }}>
          <button 
            className="btn-gestion" 
            onClick={onCancelar}
            style={{
              padding: '12px 24px',
              minWidth: '120px',
              justifyContent: 'center',
              fontWeight: '600',
              border: '1px solid var(--glass-border)',
              background: 'transparent',
              color: 'var(--text-secondary)'
            }}
          >
            Cancelar
          </button>
          <button
            className="btn-nueva"
            onClick={onConfirmar}
            style={{
              padding: '12px 24px',
              minWidth: '120px',
              justifyContent: 'center',
              fontWeight: '700',
              border: 'none',
              background: tipo === 'rojo' ? 'var(--accent-danger)' : 'var(--accent-success)',
              boxShadow: tipo === 'rojo' 
                ? '0 10px 15px -3px rgba(220, 38, 38, 0.25)' 
                : '0 10px 15px -3px rgba(5, 150, 105, 0.25)',
              color: 'white'
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
